import React from 'react';
import { ColorItem } from '@fourthwall/components';
import * as S from './CheckboxColorLabel.styled';
export const CheckboxColorLabel = ({ label, color }) => (React.createElement(S.Container, null,
    color && React.createElement(ColorItem, { color: color }),
    React.createElement("div", null, label)));
